// looks for {{some.var}}
const REGEX = /{{(.*?)}}/gi;

export const replaceVariables = (str = '', varMap): string => {
	const variables = getMatches(str || '');
	// if nothing dynamic, just return the old string
	if (!variables) return str;

	return variables.reduce((prevString, variable) => {
		const key = normalize(variable);
		const replacement = varMap[key] || '';
		const result = replaceVar(prevString, variable, replacement);
		// if we are replacing variables in a string, make sure it doesn't have extra slashes
		// else return the result
		return key === 'product.url' ? removeExtraSlashes(result) : result;
	}, str);
};

// looks for {{some.var}} and returns an array of matches
function getMatches(str): string[] {
	return str.match(REGEX);
}

function normalize(str): string {
	return str
		.replace('{{', '')
		.replace('}}', '')
		.trim();
}

function removeExtraSlashes(url): string {
	const domain = url.split('://');
	const noProtocol = domain.length === 1 ? domain[0] : domain[1];
	// if there are 2 or more slashes in a row, replace them with one;
	const cleaned = noProtocol.replace(/\/{2,}/g, '/');
	return domain.length === 1 ? cleaned : `${domain[0]}://${cleaned}`;
}

function replaceVar(str, variable, replacement): string {
	return str.replace(variable, replacement);
}
